import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PRODUCT_LOGO_SRC, PRODUCT_NAME } from '../../config/product'
import './LegalPageLayout.css'

type Props = {
  children: React.ReactNode
}

export default function LegalPageLayout({ children }: Props) {
  const { t } = useTranslation()

  return (
    <div className="legal-page">
      <header className="legal-page-header">
        <Link to="/" className="legal-page-brand" aria-label={t('legal.backToHome')}>
          <img src={PRODUCT_LOGO_SRC} alt="" className="legal-page-logo" />
          <span>{PRODUCT_NAME}</span>
        </Link>
        <Link to="/" className="legal-page-back">
          {t('legal.backToHome')}
        </Link>
      </header>
      <main className="legal-page-main">{children}</main>
    </div>
  )
}
